module.exports = __webpack_public_path__ + "img/audio.e5247b43.png";